export default class LevelModel {
  constructor({ config }) {
    this.spritesheet = config.spritesheet;

    this.vehicleVariations = config.vehicleVariations;

    this.laneCount = config.laneCount;
    this.minMoveSpeed = config.minMoveSpeed;
    this.maxMoveSpeed = config.maxMoveSpeed;

    this.fastLaneCount = config.fastLaneCount;
    this.fastLaneMinSpeed = config.fastLaneMinSpeed;
    this.fastLaneMaxSpeed = config.fastLaneMaxSpeed;
  }
}
